// Gates the down stats of a scoring play. CFL and flag football don't treat a
// touchdown as a first down, so the play records nothing at all — keeping the
// attempt without the conversion would count the touchdown as a failed down.
export default class CountTouchdownsAsFirstDownsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(gameContext, ruleContext, eventConfiguration, { play }) {
        const { touchdownsCountAsFirstDowns } =
            gameContext?.gameConfig?.general || {};

        return !ruleContext.isTouchdown || !!touchdownsCountAsFirstDowns;
    }

    // eslint-disable-next-line no-unused-vars
    async apply(gameContext, ruleContext, eventConfiguration) {}
}
